import type { SVGProps } from 'react';
import { memo } from 'react';

function Component(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="currentColor"
      viewBox="0 0 24 24"
      className="icon"
      aria-hidden="true"
      {...props}
    >
      <path d="M5 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 19V5q0-.824.587-1.412A1.93 1.93 0 0 1 5 3h8v2H5v14h14v-8h2v8q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21zm1-4h12l-3.75-5-3 4L9 13zm11-8V7h-2V5h2V3h2v2h2v2h-2v2z" />
    </svg>
  );
}
export const SvgAddPhotoAlternate = (
  props: SVGProps<SVGSVGElement>
): JSX.Element => {
  const { ...svgProps } = props;
  return <Component {...svgProps} />;
};

const Memo = memo(SvgAddPhotoAlternate);
export default Memo;
